import { Controller } from '@hotwired/stimulus'
import { mountLandingTrail } from '@/lib/landing-trail'

export default class extends Controller<HTMLElement> {
  private unmount: (() => void) | null = null

  override connect() {
    this.unmount = mountLandingTrail(this.element)
  }

  override disconnect() {
    this.unmount?.()
  }
}
